export class ReqPathData {
    [key: string]: string | string[]
}